export default "__VITE_ASSET__BklPmTTf__"